/** Once the OPD redesign is complete, id should be made non-optional */
export function linkToPatient({ id }: { id?: string } = {}): string {
  return ["/patient", id].filter(Boolean).join("/");
}
